import React from 'react'

const ThumbDownOutlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.00065 0.5H14.1673V11.3333L8.33398 17.1667L7.29232 16.125C7.1951 16.0278 7.11523 15.8958 7.05273 15.7292C6.99023 15.5625 6.95898 15.4028 6.95898 15.25V14.9583L7.87565 11.3333H2.50065C2.05621 11.3333 1.66732 11.1667 1.33398 10.8333C1.00065 10.5 0.833984 10.1111 0.833984 9.66667V8C0.833984 7.90278 0.847873 7.79861 0.875651 7.6875C0.903429 7.57639 0.931207 7.47222 0.958984 7.375L3.45898 1.5C3.58398 1.22222 3.79232 0.986111 4.08398 0.791667C4.37565 0.597222 4.68121 0.5 5.00065 0.5ZM12.5007 2.16667H5.00065L2.50065 8V9.66667H10.0007L8.87565 14.25L12.5007 10.625V2.16667ZM14.1673 11.3333V9.66667H16.6673V2.16667H14.1673V0.5H18.334V11.3333H14.1673Z'
      fill='currentColor'
    />
  </svg>
)

export default ThumbDownOutlineIcon
